export default "__VITE_ASSET__yF8G7GkX__"